import axios from 'axios';
import { API_URL } from '../configs/apiUrls';
const TOKEN_EXPIRE = 'TOKEN_EXPIRE';
export const SHOW_LOADER = 'SHOW_LOADER';
export const HIDE_LOADER = 'HIDE_LOADER'; 

export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const HIDE_SNACKBAR = 'HIDE_SNACKBAR';

export const SHOW_SUCCESS_MODAL = 'SHOW_SUCCESS_MODAL';
export const HIDE_SUCCESS_MODAL = 'HIDE_SUCCESS_MODAL';

export const showCommonLoader = (label = '') => ({
	type: SHOW_LOADER,
	common_loder_label: label
});

export const hideCommonLoader = () => ({
	type: HIDE_LOADER
});

export const showSuccessModal = (message) => ({
  type: SHOW_SUCCESS_MODAL,
  message,
});

export const hideSuccessModal = () => ({
  type: HIDE_SUCCESS_MODAL,
});


export const hideNotificationError = () => ({
  type: HIDE_SNACKBAR,
}) 

const tokenExpire = () => ({
  type: TOKEN_EXPIRE 
})

export const tokenError = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'token_expire'
})

export const showGeneralError = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'general_error'
})

export const hideSnackBarNotifications = type => {
  return dispatch => {
    if(type === 'token_expire'){
      localStorage.setItem("token", "");
      dispatch(hideNotificationError());
      dispatch(tokenExpire());
    } else if(type === 'general_error' || type === 'success'){
      dispatch({ type: HIDE_SNACKBAR });
    }
  };
};

export const logUrlVisted = (urlVisted) => {
  var token = localStorage.getItem("token");
  return dispatch => {
    return axios(API_URL + "user/logUrlVisted", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      data: { urlVisted },
    })
      .then((response) => {
        //Successfully logged
      }, (error) => {
        //handleErrorResponse(error, dispatch)
      });

  }
}

export const exportHandler = (report_url, extraFilters, object_viewed_id, filename = 'download.xlsx') => dispatch => {
  dispatch(showCommonLoader('Exporting...'));
  const token = localStorage.getItem("token");
  const url = `${API_URL + report_url}`;

  axios.post(url, {...extraFilters, object_viewed_id}, {
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
  .then(response => {
    const urlBlob = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = urlBlob;
    const contentDisposition = response.headers['content-disposition'];
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1].replace(/['"]/g, '');
      }
    }
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(urlBlob);
    dispatch(hideCommonLoader());
  }).catch(error => {
    dispatch(hideCommonLoader());
    handleErrorResponse(error, dispatch, true);
  });
};
 
const handleErrorResponse = (error, dispatch, exportError = false) => {
  try {
    if (error.response.status === 401 && error.response.data.error) {
      dispatch(tokenError(error.response.data.error.toString()))
    }
    else {
      let err = '';
      if (error.response.data.error) {
        err = error.response.data.error.toString()
      }
      else if (error.response.status == 404 && exportError) {
        err = 'No Data Available for the selected filters'
      }
      else {
        err = error.response.status + ` ` + error.response.statusText
      }
      dispatch(showGeneralError(err))
    }
  }
  catch (e) {
    dispatch(showGeneralError('Unable to perform action.Something went wrong'))
  }
}

export const fetchUsersDropdown = () => (dispatch) => {
  const token = localStorage.getItem("token");
  axios
    .get(`${API_URL}admin/users-dropdown`, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      dispatch({
        type: 'FETCH_USERS_DROPDOWN',
        payload: response.data.data,
      });
    })
    .catch((error) => {
      handleErrorResponse(error, dispatch);
    });
};